import DateTimeUtils from '@/utils/datetime';
import ToastUtils from '@/utils/toast';
import { mapActions, mapState } from 'vuex';

const CheckPermissionMixin = {
  name: 'CheckPermissionMixin',
  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapState(['activeAnnouncementLines']),
    hasPermissionToPublishInvoice() {
      return (
        this.activeAnnouncementLines &&
        this.activeAnnouncementLines.list_invoice_type &&
        this.activeAnnouncementLines.list_invoice_type.length > 0
      );
    },
  },
  methods: {
    ...mapActions(['getSellerSettingList']),
    isValidLicense() {
      if (
        this.currentUser &&
        this.currentUser.company &&
        this.currentUser.company.service_status &&
        this.currentUser.company.service_status.lics &&
        this.currentUser.company.service_status.lics.EINVOICE
      ) {
        const { capacity, count, end } = this.currentUser.company.service_status.lics.EINVOICE;

        if (capacity === null || capacity > count) {
          if (end) {
            const endDate = DateTimeUtils.parseDate(end).toDate();
            return DateTimeUtils.diff(endDate, new Date(), 'days') >= 1;
          }
          return true;
        }
      }
      return false;
    },

    determineModalName(name = 'create-invoice-form-modal') {
      this.getSellerSettingList().then(r => r);
      if (!this.isValidLicense()) {
        ToastUtils.showToast('warning', 'Bạn đã chưa được cấp quyền phát hành hóa đơn!');
        return 'adv-modal';
      }
      if (this.hasPermissionToPublishInvoice) {
        return name;
      }
      return 'publish-invoice-info-modal';
    },
  },
};

export default CheckPermissionMixin;



// WEBPACK FOOTER //
// ./src/mixins/check-permission.js